<script>
    import { onMount } from "svelte";

    // 数据
    let sleeptime_config = [];
    let sleeptime_executed = 0;
    let gasstatus_config = [];
    let gasstatus_executed = 0;
    let frmToAddDevice = "";
    let frmToAddSleep = "240";
    let frmToAddDevice2 = "";
    let frmToAddGasStatus = "1";

    let dlg_rtdata_title = "";
    let dlg_rtdata_display = "";

    // 提示框配置
    toastr.options = {
        positionClass: "toast-top-center",
    };

   // 加载事件函数
   onMount(() => {
        loadConfig();
    });

    function loadConfig() {
        let sKey = "IOTCF@command@sleeptime";
        let tmpUrl = "/rtapi/readsingledata?k=" + sKey;
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    try {
                        let objConfig = JSON.parse(response.result);
                        //console.log(objConfig);
                        if ((objConfig.data != undefined) && (objConfig.status != undefined)) {
                            sleeptime_executed = objConfig.status;
                            for (let kk in objConfig.data) {
                                if (kk != "") {
                                    let vv = objConfig.data[kk].toString();
                                    sleeptime_config.push({kstr:kk,vstr:vv});
                                }
                            }
                            sleeptime_config = sleeptime_config;
                        }
                    } catch (error) {
                        console.log("load sleeptime configure error: ",error.message);
                    }
                } else {
                    getValstr = "err";
                }
            },
            error: function (err) {
                getValstr = err;
            },
        });

        sKey = "IOTCF@command@gasstatus";
        tmpUrl = "/rtapi/readsingledata?k=" + sKey;
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    try {
                        let objConfig = JSON.parse(response.result);
                        //console.log(objConfig);
                        if ((objConfig.data != undefined) && (objConfig.status != undefined)) {
                            gasstatus_executed = objConfig.status;
                            for (let kk in objConfig.data) {
                                if (kk != "") {
                                    let vv = objConfig.data[kk].toString();
                                    gasstatus_config.push({kstr:kk,vstr:vv});
                                }
                            }
                            gasstatus_config = gasstatus_config;
                        }
                    } catch (error) {
                        console.log("load gasstatus configure error: ",error.message);
                    }
                } else {
                    getValstr = "err";
                }
            },
            error: function (err) {
                getValstr = err;
            },
        });

        /*let tmpUrl = "/rtapi/getdevlist";
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        devcodes = response.result;
                        totalcount = devcodes.length;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });*/

    }

    function addToSleepConfig() {
        if (frmToAddDevice.trim() == "") {
            return;
        }
        let nFound = -1;
        for (let i = 0; i < sleeptime_config.length; i++) {
            if (sleeptime_config[i].kstr == frmToAddDevice) {
                nFound = i;
            }
        }
        if (nFound == -1) {
            let sleepchoices = ["15","30","60","120","240","360","720"];
            if (sleepchoices.includes(frmToAddSleep)) {
                sleeptime_config.push({kstr:frmToAddDevice,vstr:frmToAddSleep});
                sleeptime_config = sleeptime_config;
            } else {
                toastr.error("休眠时间不符合标准，不允许添加");
            }
        } else {
            toastr.error("设备唯一编号已经存在，不允许重复添加");
        }
    }

    function delFromSleepConfig(devid) {
        if (window.confirm("删除"+devid+"该项配置，是否继续？")) {
            let nFound = -1;
            for (let i = 0; i < sleeptime_config.length; i++) {
                if (sleeptime_config[i].kstr == devid) {
                    nFound = i;
                }
            }
            if (nFound != -1) {
                sleeptime_config.splice(nFound,1);
                sleeptime_config = sleeptime_config;
            }
        }
    }

    function saveSleepToPlatform() {
        if (window.confirm("将休眠时间控制配置同步至平台，是否继续？")) {
            let objTmp = {};
            for (let i = 0; i < sleeptime_config.length; i++) {
                let vvv = parseInt(sleeptime_config[i].vstr);
                objTmp[sleeptime_config[i].kstr] = vvv;
            }
            let strToSave = JSON.stringify({data:objTmp,status:0})
            // 写入后台
            let tmpUrl = "/rtapi/writertdatas";
            let reqprops = [];
            let keyprop = "IOTCF@command@sleeptime";
            let rtdata = {rtkey: keyprop,rtval:strToSave};
            reqprops.push(rtdata);
            jQuery.ajax({
                type: "post",
                url: tmpUrl,
                data: JSON.stringify(reqprops),
                success: function (response) {
                    if (response.code == 200) {
                        toastr.info("休眠时间控制配置写入成功");
                    } else {
                        toastr.error("休眠时间控制配置写入失败");
                    }
                },
                error: function (err) {
                    toastr.error("休眠时间控制配置写入异常:" + err);
                }
            });
        }
    }

    function addToGasConfig() {
        if (frmToAddDevice2.trim() == "") {
            return;
        }
        let nFound = -1;
        for (let i = 0; i < gasstatus_config.length; i++) {
            if (gasstatus_config[i].kstr == frmToAddDevice2) {
                nFound = i;
            }
        }
        if (nFound == -1) {
            let gaschoices = ["0","1"];
            if (gaschoices.includes(frmToAddGasStatus)) {
                gasstatus_config.push({kstr:frmToAddDevice2,vstr:frmToAddGasStatus});
                gasstatus_config = gasstatus_config;
            } else {
                toastr.error("气体模块状态不符合标准，不允许添加");
            }
        } else {
            toastr.error("设备唯一编号已经存在，不允许重复添加");
        }
    }

    function delFromGasConfig(devid) {
        if (window.confirm("删除"+devid+"该项配置，是否继续？")) {
            let nFound = -1;
            for (let i = 0; i < gasstatus_config.length; i++) {
                if (gasstatus_config[i].kstr == devid) {
                    nFound = i;
                }
            }
            if (nFound != -1) {
                gasstatus_config.splice(nFound,1);
                gasstatus_config = gasstatus_config;
            }
        }
    }

    function saveGasToPlatform() {
        if (window.confirm("将气体模块控制配置同步至平台，是否继续？")) {
            let objTmp = {};
            for (let i = 0; i < gasstatus_config.length; i++) {
                let vvv = parseInt(gasstatus_config[i].vstr);
                objTmp[gasstatus_config[i].kstr] = vvv;
            }
            let strToSave = JSON.stringify({data:objTmp,status:0})
            // 写入后台
            let tmpUrl = "/rtapi/writertdatas";
            let reqprops = [];
            let keyprop = "IOTCF@command@gasstatus";
            let rtdata = {rtkey: keyprop,rtval:strToSave};
            reqprops.push(rtdata);
            jQuery.ajax({
                type: "post",
                url: tmpUrl,
                data: JSON.stringify(reqprops),
                success: function (response) {
                    if (response.code == 200) {
                        toastr.info("气体模块状态控制配置写入成功");
                    } else {
                        toastr.error("气体模块状态控制配置写入失败");
                    }
                },
                error: function (err) {
                    toastr.error("气体模块状态控制配置写入异常:" + err);
                }
            });
        }
    }

    function showRtdata(code) {
        dlg_rtdata_title = "设备" + code + "的实时数据";
        let tmpUrl1 = "/rtapi/getdevrtdatas?code=" + code;
        let tmpUrl2 = "/rtapi/getdevregdatas?code=" + code;
        // 实时数据
        jQuery.ajax({
            type: "get",
            url: tmpUrl1,
            success: function (response) {
                if (response.code == 200) {
                    let robj = response.result;
                    //console.log(robj);
                    let sHtml = "";
                    if (robj.devcode == undefined) {
                        sHtml = "<li>找不到数据</li>";
                    } else {
                        sHtml += "<li>设备号：" + robj.devcode + "</li>";
                        sHtml += "<li>更新时间：" + robj.lastupdate + "</li>";
                        if (robj.props != undefined) {
                            for (let i=0;i<robj.props.length;i++)
                            {
                                sHtml +=  ("<li>" + robj.props[i].propertyname + "：" + robj.props[i].rtval + "</li>")
                            }
                        }
                        // 注册数据
                        jQuery.ajax({
                            type: "get",
                            url: tmpUrl2,
                            success: function (response2) {
                                let robj2 = response2.result;
                                //console.log(robj2);
                                if (robj2.props != undefined) {
                                    for (let i=0;i<robj2.props.length;i++)
                                    {
                                        sHtml +=  ("<li>" + robj2.props[i].propertyname + "：" + robj2.props[i].rtval + "</li>")
                                        dlg_rtdata_display = sHtml
                                    }
                                }
                            }
                        });
                    }
                    dlg_rtdata_display = sHtml
                    jQuery("#rtdata-modal").modal("show");
                } else {
                    toastr.error("调取实时数据错误:");
                }
            },
            error: function (err) {
                console.log(err);
                toastr.error("调取实时数据异常:");
            },
        });
    }

    function closeRtdata() {
        jQuery("#rtdata-modal").modal("hide");
    }

</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>远程控制</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">休眠时间配置修改</h3>
                            <div class="card-tools">
                                &nbsp;
                            </div>
                        </div>
                        <div class="card-body" styel="height:300px">
                            <div class="form-group row">
                                <label for="frmProperty" class="col-sm-2 col-form-label">填写休眠配置:</label>
                                <div class="col-sm-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="frmDeviceToadd"
                                        bind:value={frmToAddDevice}
                                        placeholder=""
                                        title="设备唯一编号"
                                    />
                                </div>
                                <div class="col-sm-2">
                                    <select
                                        class="form-control"
                                        id="frmPropertySleep"
                                        bind:value={frmToAddSleep}
                                        title="休眠时间"
                                    >
                                        <option value="15">15分钟</option>
                                        <option value="30">30分钟</option>
                                        <option value="60">60分钟</option>
                                        <option value="120">120分钟</option>
                                        <option value="240">240分钟</option>
                                        <option value="360">360分钟</option>
                                        <option value="720">720分钟</option>
                                    </select>
                                </div>
                                <div class="col-sm-5">
                                    <button type="submit" class="btn btn-default" on:click={addToSleepConfig}>
                                        <i class="bi bi-clipboard-plus"></i> 添加
                                    </button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="submit" class="btn btn-default" on:click={saveSleepToPlatform}>
                                        <i class="bi bi-arrow-left-right"></i> 同步
                                    </button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <span style="font-size:14px">下发状态：{sleeptime_executed}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <table class="table table-bordered table-hover">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="30%">设备唯一编码</th>
                                                <th width="30%">休眠时间(单位：分钟)</th>
                                                <th width="40%">操作</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-sm-12" style="max-height:180px;overflow:auto;">
                                    <table class="table table-bordered table-hover">
                                        <tbody>
                                            {#each sleeptime_config as conf}
                                            <tr>
                                                <td width="30%">{conf.kstr}</td>
                                                <td width="30%">{conf.vstr}</td>
                                                <td width="40%">
                                                    <i
                                                        class="bi bi-journal-text"
                                                        on:click={() => showRtdata(conf.kstr)}
                                                        on:keyup={() => {}} role="button" tabindex="0"
                                                    />
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <i
                                                        class="bi bi-journal-x"
                                                        on:click={() => delFromSleepConfig(conf.kstr)}
                                                        on:keyup={() => {}} role="button" tabindex="0"
                                                    />
                                                </td>
                                            </tr>
                                            {/each}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end of card -->
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">气体传感器状态修改</h3>
                            <div class="card-tools">
                                &nbsp;
                            </div>
                        </div>
                        <div class="card-body" styel="height:300px">
                            <div class="form-group row">
                                <label for="frmProperty" class="col-sm-2 col-form-label">填写气体模块配置:</label>
                                <div class="col-sm-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="frmDeviceToAdd2"
                                        bind:value={frmToAddDevice2}
                                        placeholder=""
                                        title="设备唯一编号"
                                    />
                                </div>
                                <div class="col-sm-2">
                                    <select
                                        class="form-control"
                                        id="frmPropertyGasStatus"
                                        bind:value={frmToAddGasStatus}
                                        title="气体模块状态"
                                    >
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                    </select>
                                </div>
                                <div class="col-sm-5">
                                    <button type="submit" class="btn btn-default" on:click={addToGasConfig}>
                                        <i class="bi bi-clipboard-plus"></i> 添加
                                    </button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="submit" class="btn btn-default" on:click={saveGasToPlatform}>
                                        <i class="bi bi-arrow-left-right"></i> 同步
                                    </button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <span style="font-size:14px">下发状态：{gasstatus_executed}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <table class="table table-bordered table-hover">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="30%">设备唯一编码</th>
                                                <th width="30%">模块状态(0 停;1 用)</th>
                                                <th width="40%">操作</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-sm-12" style="max-height:180px;overflow:auto;">
                                    <table class="table table-bordered table-hover">
                                        <tbody>
                                            {#each gasstatus_config as conf}
                                            <tr>
                                                <td width="30%">{conf.kstr}</td>
                                                <td width="30%">{conf.vstr}</td>
                                                <td width="40%">
                                                    <i
                                                        class="bi bi-journal-text"
                                                        on:click={() => showRtdata(conf.kstr)}
                                                        on:keyup={() => {}} role="button" tabindex="0"
                                                    />
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <i
                                                        class="bi bi-journal-x"
                                                        on:click={() => delFromGasConfig(conf.kstr)}
                                                        on:keyup={() => {}} role="button" tabindex="0"
                                                    />
                                                </td>
                                            </tr>
                                            {/each}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end of card -->
                </div>
            </div>
        </div>
    </section>
</div>

<!-- rtdata modal dialog -->
<div class="modal fade" id="rtdata-modal" data-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{dlg_rtdata_title}</h4>
                <button
                    type="button"
                    class="close"
                    on:click={closeRtdata}
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ul>{@html dlg_rtdata_display}</ul>
            </div>
            <div class="modal-footer justify-content-between">
                <button
                    type="button"
                    class="btn btn-default"
                    on:click={closeRtdata}
                >关闭</button>
            </div>
        </div>
    </div>
</div>
<!-- /rtdata modal dialog -->

<style>
</style>
